import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'colorealert'
})
export class ColoreAlertPipe implements PipeTransform {
    transform(value: number): string {
        let colorealert: string;
        if (value != null) {
            switch (value) {
                case 1298:
                    colorealert = "orange";
                    break;
                case 1300:
                    colorealert = "red";
                    break;
                case 1297:
                    colorealert = "white";
            }
        }
        return colorealert;
    }
}

